import { ICampaignPrices } from 'interfaces/campaigns';
import axios, { Response } from 'services';

export interface IYandexError {
	Code: number;
	Details: string;
	Message: string;
}

export interface IYCompanyResponse {
	address: string;
	country: {
		geoId: number;
		name: string;
		isAdvertisingDisabled: boolean;
	};
	id: number;
	isChain: boolean;
	isOnline: boolean;
	name: string;
	rubrics: number;
	url: string;
};
export interface IYCompaniesResponse {
	companies: [];
};
export const yandexCompanySearch = (companyName: string): Response<IYCompaniesResponse> => {
	return axios.post(`/partner/yandex/company-search`, {}, {
		params: {
		  text: companyName,
		  limit: 10,
		  offset: 0
		}
	});
};

export interface IAdvertisingPriceRequest {
	id: number;
	branding: boolean;
	campaignId: number;
	chainId: number;
	companyId: number | string;
	countryGeoId: number | string;
};
export const yandexAdvertisingPrice = (payload: IAdvertisingPriceRequest): Response<ICampaignPrices> => {
	return axios.post(`/partner/yandex/price`, payload);
};

export interface IAddClientRequest {
	login: string;
	company_id: string | number;
};
export interface IAddClientResponse {
	ClientId: number;
	Email: string;
	Login: string;
	Password: string;
	Warnings: IYandexError[];
	Errors: IYandexError[];
	status?: string;
	message?: string;
};
export const yandexAddClient = (payload: IAddClientRequest): Response<IAddClientResponse> => {
	return axios.post(`/partner/yandex/add_client`, payload);
};

export interface IPromocodeRequest {
	promocode: string;
	advert_campaign_id: number;
};
export interface IPromocodeResponse {
	applicable: boolean;
	promocode: string;
};
export const yandexActivatePromocode = (payload: IPromocodeRequest): Response<IPromocodeResponse> => {
	return axios.post(`/partner/yandex/activate_promocode`, payload);
};
export const yandexDeactivatePromocode = (payload: IPromocodeRequest): Response<IPromocodeResponse> => {
	return axios.post(`/partner/yandex/deactivate_promocode`, payload);
};

export interface IYCompanyRightsRequest {
	companyId: string | number;
	subclientId: string | number;
};
export interface IYCompanyRightsResponse {
	owned: boolean;
};
export const yandexCheckCompanyRights = (payload: IYCompanyRightsRequest): Response<IYCompanyRightsResponse> => {
	const { companyId, subclientId } = payload;
	return axios.get(`/partner/yandex/companies/${companyId}/is-owned`, { params: { subclient_id: subclientId } });
};

export interface ISetPasswordChangedRequest {
	company_id: number | string;
	subclient_id: number | string;
	is_temporary: boolean;
};
export const yandexSetPasswordChanged = (payload: ISetPasswordChangedRequest): Response<any> => {
	return axios.post(`/partner/yandex/toggle_temporary_password`, payload);
};
